import styled from "styled-components";

const MessagesContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
`;

export default MessagesContainer;
